import React from "react";
import { Control, FieldErrors } from "react-hook-form";
import GlobalPageFilterFields from "../form/GlobalPageFilterFields";
import { useTranslations } from "next-intl";

type TGlobalPageFilterSidebar = {
  control: Control;
  errors: FieldErrors;
};

const GlobalPageFilterSidebar = ({
  control,
  errors,
}: TGlobalPageFilterSidebar) => {
  const t = useTranslations();

  return (
    <div className="space-y-6">
      <h3 className="text-lg font-semibold">{t("Filter Content")}</h3>
      <GlobalPageFilterFields control={control} errors={errors} />
    </div>
  );
};

export default GlobalPageFilterSidebar;
